<template>
  <el-autocomplete
      class="inline-input"
      v-model="name"
      :fetch-suggestions="querySearch"
      placeholder="请输入"
      @select="handleSelect"
  >
    <template slot-scope="{ item }">
      <div class="flex">
        <div>{{ item.name }}</div>
        <div style="margin-left: auto">{{ item.code }}</div>
      </div>
    </template>
  </el-autocomplete>
</template>
<script>
export default {
  name: "DicInput",
  data() {
    return {
      name: "",
      restaurants: [],
    }
  },
  components: {
    //someComponent
  },
  props: {
    dicType: '',
    url: '',
    initName: '',
    defaultName: '',
  },
  watch: {
    defaultName: {
      handler(newName, oldName) { //特别注意，不能用箭头函数，箭头函数，this指向全局
        this.name = newName
      },
      immediate: true,  //刷新加载 立马触发一次handler
      deep: true  // 可以深度检测到 obj 对象的属性值的变化
    },
    initName: {
      handler(newName, oldName) { //特别注意，不能用箭头函数，箭头函数，this指向全局
        if (newName === '' || newName === null) {
          this.name = ''
        }
      },
      immediate: true,  //刷新加载 立马触发一次handler
      deep: true  // 可以深度检测到 obj 对象的属性值的变化
    }
  },
  methods: {
    //
    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0 || restaurant.server.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },
    handleSelect(item) {
      this.name = item.name;
      this.$emit('fieldId', item)
    },
    list() {
      let Url = this.url
      let data = {
        page: 1,
        pageSize: 1000,
      }
      this.axios
          .get(Url, {params: data})
          .then((res) => {
            this.restaurants = res.list
            this.restaurants.forEach(item => {
              item.name = item.dataBaseName
              item.name = item.dataBaseName
            })
          })
    }
  },
  mounted() {
    //
    this.list()
  }
}
</script>

<style lang="scss" scoped>
.Dic {

}
</style>